import { StorageKeys } from 'common'
import { IS_CCL_ENABLED } from 'src/config/ConfigManager'
import { Vehicle } from 'src/store/models/Vehicles'
import { StoreInstances } from 'src/store/StoreInstancesContainer'

export const getSavedVehicleRegion = (): number | undefined => {
  if (!IS_CCL_ENABLED) return undefined

  const regionIdValue = localStorage.getItem(
    StorageKeys.SAVED_VEHICLE_REGION_ID
  )

  if (!regionIdValue || regionIdValue === 'undefined') return undefined

  let regionId: number | undefined

  try {
    regionId = JSON.parse(regionIdValue)
  } catch {
    return undefined
  }

  if (StoreInstances?.userStore?.activeCatalogPublisherId !== 1)
    return undefined

  return regionId
}

export const getVehicleRegionId = (
  vehicle?: Vehicle,
  cclRegionIds?: number[],
  userRegionId?: number
): number | undefined => {
  if (!IS_CCL_ENABLED) return undefined

  // Use vehicle's regionId if available
  if (vehicle?.regionId) {
    return vehicle.regionId
  }

  // Check CCL vehicle data region IDs
  if (Array.isArray(cclRegionIds)) {
    if (cclRegionIds.length === 1) {
      return cclRegionIds[0]
    }
    if (userRegionId && cclRegionIds.includes(userRegionId)) {
      return userRegionId
    }
    if (cclRegionIds.includes(19)) {
      return 19
    }
    return cclRegionIds[0]
  }

  // Check engine region IDs
  if (Array.isArray(vehicle?.engine?.regionIds)) {
    const engineRegionIds = vehicle.engine.regionIds
    if (engineRegionIds.length === 1) {
      return engineRegionIds[0]
    }
    if (userRegionId && engineRegionIds.includes(userRegionId)) {
      return userRegionId
    }
    if (engineRegionIds.includes(19)) {
      return 19
    }
    return engineRegionIds[0]
  }

  return (
    StoreInstances.userStore.decodeRegionId ??
    getSavedVehicleRegion() ??
    userRegionId
  )
}
